export default "<button>{{$ctrl.prompt}}</button>"